import { defineMessages } from 'react-intl';

export const message = defineMessages({
  noImpersonationMessage: {
    id: 'COMMON.HEADER.NOIMPERSONATIONPERMISSION',
    defaultMessage:
      'Sorry, you don’t have the required permission to impersonate this enterprise'
  }
});
